module.exports = __webpack_public_path__ + "static/media/img_1_1685961600020.b024566e.jpg";